import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { CfCliTemplateReportStampa, DataGridCfCliTemplateReportStampa as StampaRequest } from './clientiTemplateSlice'

export const clientiTemplateApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT + '/stampe' }),
    reducerPath: 'clientiTemplateApi',
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        post: build.mutation<any, StampaRequest>({
            query: (body) => ({
                url: `/all`,
                method: 'POST',
                body,
            }),
            //invalidatesTags: ['all'],
            transformResponse: (response: any) => {
                return response
            },
        }),
        insertOrUpdateTemplateReportStampa: build.mutation<any, CfCliTemplateReportStampa>({
            query: (body) => ({
                url: `/insertOrUpdateTempalteReportStampa`,
                method: 'PUT',
                body,
            }),
            //invalidatesTags: ['all'],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { usePostMutation, useInsertOrUpdateTemplateReportStampaMutation } = clientiTemplateApi
